<template>
    <div :id="id" class="form-group mod">
        <label class="m-0 f-14 f-regular f-c-midgrey" :class="{ require: required }">
            {{ title }}
        </label>
        <div class="so-modal-options row" @click="showOptions" v-if="!selectedItem">
            <div class="p-0 col-md-11 col-sm-11 col-11">
                <div class="header">
                    <label class="f-regular f-16 m-0" style="color: #e5e5e5">{{ placeholder }}</label>
                </div>
            </div>
            <div class="p-0 col-md-1 col-sm-1 col-1" style="align-self: flex-start;">
                <img src="../../../assets/icon-sidebar/chevron-down.svg" />
            </div>
        </div>
        <div class="so-modal-options row" @click="showOptions" v-else :class="{'bg-grey': disabled}">
            <div class="p-0 col-md-11 col-sm-11 col-11">
                <div class="header">
                    <label class="f-regular f-c-black f-16 m-0">{{ selectedItem.title }}</label>
                </div>
                <label class="f-c-midgrey f-12 f-regular m-0" v-html="selectedItem.information"></label>
            </div>
            <div class="p-0 col-md-1 col-sm-1 col-1">
                <img src="../../../assets/icon-sidebar/chevron-down.svg" />
            </div>
        </div>
        <SOSlotModal :modal-title="`${title}`" :modal-id="`modal-${id}`" @close="hideOptions">
            <template v-slot:modal-body>
                <div
                    style="max-height: 450px; overflow-y: scroll; overflow-x: hidden;"
                    :id="`modal-body-${id}`"
                    class="m-body"
                >
                    <div
                        :class="
                            `custom-control row custom-radio p-y-12 p-x-16 options ${
                                radio.value == optValue ? 'option-selected' : ''
                            }`
                        "
                        v-for="(radio, idx) in options"
                        :key="`${id}${idx}`"
                        @click="onSelect(radio)"
                    >
                        <input
                            class="custom-control-input"
                            type="radio"
                            :id="`${id}${idx}`"
                            :name="`options-${id}`"
                            :value="radio.value"
                            :checked="radio.value == optValue"
                        />
                        <label class="custom-control-label f-regular f-16 f-c-black" :for="`${id}${idx}`">
                            {{ radio.title }}
                        </label>
                        <div class="option-information">
                            <label
                                class="f-regular f-c-midgrey f-12 m-d-0"
                                :for="`${id}${idx}`"
                                v-html="radio.information"
                            >
                            </label>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div v-if="isBtnLink" style="text-align: left;">
                    <SOButtonPlusLink :id="id" :text="textLink" @action="linkAction" />
                </div>
                <div v-else>
                    <SOButton :outline="true" :full="true" :text="'Pilih'" :id="id" @action="onPilih" />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOButtonPlusLink from "@/so-components/global/ui/SOButtonPlusLink";

export default {
    name: "SoModalOptions",
    components: {
        SOSlotModal,
        SOButton,
        SOButtonPlusLink,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
        },
        selectedOption: {
            type: Number | String,
            default: 0,
        },
        options: {
            type: Array,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        textLink: String,
        isBtnLink: Boolean,
        required: Boolean,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShownOption: false,
            optSelected: {},
        };
    },
    watch: {
        isShownOption: function(newIsShownOption, oldisShownOption) {
            if (newIsShownOption !== oldisShownOption) {
                if (newIsShownOption) {
                    this.initSelected();
                    $(`#modal-${this.id}`).modal("show");
                } else {
                    $(`#modal-${this.id}`).modal("hide");
                }
            }
        },
    },
    computed: {
        selectedItem: function() {
            return this.options.find((opt) => opt.value === this.selectedOption);
        },
        optValue: function() {
            return this.optSelected ? this.optSelected.value : null;
        },
    },
    methods: {
        initSelected() {
            this.optSelected = this.options.find((opt) => opt.value === this.selectedOption);
        },
        showOptions() {
            if (this.disabled === false) {
                this.isShownOption = true;
                this.activeElement();
                this.scrollToView();
            }
        },
        hideOptions() {
            this.isShownOption = false;
            this.optSelected = null;
        },
        onSelect(obj) {
            this.optSelected = obj;

            if (this.isBtnLink) {
                this.$emit("onSelected", obj);
                this.hideOptions();
            }
        },
        onPilih(e) {
            e.preventDefault();
            this.$emit("onSelected", this.optSelected);
            this.hideOptions();
        },
        linkAction() {
            this.$emit("linkAction");
            this.hideOptions();
        },
        scrollToView() {
            if (this.selectedOption) {
                let elmnt = document.getElementById(`${this.id}${this.selectedOption - 1}`);
                elmnt.scrollIntoView();
            }
        },
        activeElement() {
            let elm = document.getElementById(`modal-body-${this.id}`);
            elm.querySelector("input").focus();
            elm.focus();
        },
    },
};
</script>

<style scoped>
.p-x-0 {
    padding-left: 0px;
    padding-right: 0px;
}
.so-modal-options {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 3px;
    margin-left: 0px;
    margin-right: 0px;
    padding: 12px 16px;
}

.so-modal-options div:nth-child(2) img {
    height: 20px;
    position: absolute;
    top: 37.5%;
    right: 0px;
}

.options {
    border-bottom: 1px solid #ededed;
}

.option-information {
    padding-left: 24px;
}

.option-selected {
    background: #f0f7ff;
}

.m-body:focus {
}
</style>
